import React, { forwardRef } from 'react'
import { ChevronDown } from 'lucide-react'

const Select = forwardRef(({
  label,
  error,
  options = [],
  placeholder = 'Select an option',
  helpText,
  className = '',
  containerClassName = '',
  ...props
}, ref) => {
  // Check if field is empty/incomplete (only for required fields)
  const isEmpty = props.value !== undefined && (!props.value || props.value === '')
  const showIncompleteStyle = isEmpty && (props.required || label?.includes('*'))

  return (
    <div className={`w-full ${containerClassName}`}>
      {label && (
        <label className="block text-sm font-medium text-slate-700 mb-1.5">
          {label}
        </label>
      )}
      <div className="relative">
        <select
          ref={ref}
          className={`
            w-full px-4 py-3 pr-10
            appearance-none
            border-2 rounded-lg bg-white
            ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : showIncompleteStyle ? 'border-orange-500 focus:ring-orange-500 focus:border-orange-500' : 'border-slate-300 focus:ring-primary-500 focus:border-primary-500'}
            focus:outline-none focus:ring-2
            transition-colors duration-200
            disabled:bg-slate-100 disabled:cursor-not-disabled
            ${className}
          `}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
          <ChevronDown className="w-5 h-5 text-slate-400" />
        </div>
      </div>
      {error && (
        <p className="mt-1.5 text-sm text-red-600">{error}</p>
      )}
      {helpText && !error && (
        <p className="mt-1.5 text-sm text-slate-500">{helpText}</p>
      )}
    </div>
  )
})

Select.displayName = 'Select'

export default Select
